import { render } from "./ArrowControls.vue?vue&type=template&id=3d71f736"
import script from "./ArrowControls.vue?vue&type=script&lang=js"
export * from "./ArrowControls.vue?vue&type=script&lang=js"

import "./ArrowControls.vue?vue&type=style&index=0&id=3d71f736&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__